<div
    class="cat"
    [ngClass]="{ 'cat--reverse': reverse, 'cat--fast': fast, 'cat--slow': slow, 'cat--small': small }"
></div>
